import { BTTSessionChart, type BTTChartOptions } from '~/components/reports/BTTSessionChart';

export interface BTTDataSet {
  timestamp: string | Date;
  pressSnsrExtractdBar: number;
  pressSnsrrRetractdBar: number;
  pullForceKg: number;
  tonsSetPoint: number;
}

export class BTTSession {
  bttChart: BTTSessionChart<BTTDataSet>;

  constructor(opts: BTTChartOptions) {
    this.bttChart = new BTTSessionChart<BTTDataSet>(opts);
    const seriesColors = ['#1395BA', '#0D3C55', '#F16C20', '#F2B705'];

    this.bttChart
      .addLineSeries({
        name: 'Extract Pressure (bar)',
        color: seriesColors[0],
        formatter: value => `${value.toFixed(1)} bar`,
        map: values => values.map(d => ({ x: new Date(d.timestamp).getTime(), y: d.pressSnsrExtractdBar })),
      })
      .addLineSeries({
        name: 'Retract Pressure (bar)',
        color: seriesColors[1],
        formatter: value => `${value.toFixed(1)} bar`,
        map: values => values.map(d => ({ x: new Date(d.timestamp).getTime(), y: d.pressSnsrrRetractdBar })),
      })
      .addLineSeries({
        name: 'Pull Force (kg)',
        yAxis: { axis: this.bttChart.rightYAxis, opposite: true },
        color: seriesColors[2],
        formatter: value => `${value.toFixed(0)} kg`,
        map: values => values.map(d => ({ x: new Date(d.timestamp).getTime(), y: d.pullForceKg })),
      })
      .addLineSeries({
        name: 'Set Point (kg)',
        yAxis: { axis: this.bttChart.rightYAxis, opposite: true },
        color: seriesColors[3],
        formatter: value => `${(value).toFixed(2)} t`,
        map: values => values.map(d => ({ x: new Date(d.timestamp).getTime(), y: d.tonsSetPoint})),
      })
      .addLegendBox(
        this.bttChart.series.filter(s => s.series.getVisible() === true),
        undefined,
        { x: 50, y: 0 },
      )
      .addCustomCursor(this.bttChart.xAxis, this.bttChart.leftYAxis, this.bttChart.rightYAxis);
  }

  add(data: BTTDataSet[]) {
    this.bttChart.add(data);
    return this;
  }

  clear() {
    this.bttChart.clear();
    return this;
  }
}
